<div class="wrapper">
  <div class="wrapper-header">
    <i class="fal fa-route"></i>
    {{ 'i18n.common.itinerary' | translate }}: {{ totalDuration() }} ({{
      totalDistance()
    }})
  </div>
  <div class="wrapper-content">
    <div class="wrapper-step">
      <div class="icon">
        <i class="fas fa-{{ iconStart() }}"></i>
      </div>
      <div class="title">
        @if (directionsLeg() && directionsLeg().start_address) {
          {{ directionsLeg().start_address }}
        } @else {
          {{ 'i18n.common.google.start-unknown' | translate }}
        }
      </div>
      <div class="duration-km bold">
        {{ 'i18n.common.google.start' | translate }}
      </div>
    </div>
    @for (step of steps(); track step; let i = $index) {
      <div class="wrapper-step">
        <div class="icon">
          @if (step.maneuver) {
            <div class="adp-maneuver adp-{{ step.maneuver }}"></div>
          }
        </div>
        <div [innerHTML]="step.instructions"></div>
        <div class="duration-km">
          {{ step.duration.text }}
          <br />
          ({{ step.distance.value | googleDistance }})
        </div>
      </div>
    }
    <div class="wrapper-step">
      <div class="icon">
        <i class="fas fa-flag-checkered"></i>
      </div>
      <div class="title">
        @if (directionsLeg() && directionsLeg().end_address) {
          {{ directionsLeg().end_address }}
        } @else {
          {{ 'i18n.common.google.end-unknown' | translate }}
        }
      </div>
      <div class="duration-km bold">
        {{ 'i18n.common.google.end' | translate }}
      </div>
    </div>
  </div>
</div>
